import { fetchWrapper } from "@/helpers/fetch-wrapper";

class ContactGroupsService {
  CONTACT_GROUPS_API_DISABLED_KEY = "contact_groups_api_disabled";

  isApiDisabled() {
    try {
      return window.localStorage.getItem(this.CONTACT_GROUPS_API_DISABLED_KEY) === "1";
    } catch (error) {
      return false;
    }
  }

  markApiDisabled() {
    try {
      window.localStorage.setItem(this.CONTACT_GROUPS_API_DISABLED_KEY, "1");
    } catch (error) {
      // ignore localStorage errors
    }
  }

  isNotFoundError(error) {
    if (error === 404 || error === "404") {
      return true;
    }

    if (typeof error === "string") {
      const normalized = error.toLowerCase();
      return normalized.includes("404") || normalized.includes("not found");
    }

    if (typeof error?.message === "string") {
      const normalized = error.message.toLowerCase();
      return normalized.includes("404") || normalized.includes("not found");
    }

    return false;
  }

  async getAll() {
    if (this.isApiDisabled()) {
      return [];
    }

    const params = new URLSearchParams({
      orderDirection: 'desc',
      page: 1,
      limit: 1000,
    });

    let response;
    try {
      response = await fetchWrapper.get(
        `${process.env.VUE_APP_API_URL}/wanted-contact-groups?${params.toString()}`
      );
    } catch (error) {
      if (this.isNotFoundError(error)) {
        this.markApiDisabled();
        return [];
      }
      throw error;
    }

    if (Array.isArray(response)) {
      return response;
    }

    if (response == null) {
      return [];
    }

    if (Array.isArray(response.items)) {
      return response.items;
    }

    if (Array.isArray(response.data)) {
      return response.data;
    }

    return [];
  }

  async add(name, description = '', contactIds = [], userIds = null) {
    if (!name || String(name).trim() === '') {
      throw new Error('Group name is required.');
    }

    const body = {
      name: String(name).trim(),
      description: description ?? '',
      contactIds: Array.isArray(contactIds) ? contactIds : [],
    };

    if (userIds !== null) {
      body.userIds = Array.isArray(userIds) ? userIds : [];
    }

    return fetchWrapper.post(`${process.env.VUE_APP_API_URL}/wanted-contact-groups`, body);
  }

  async update(id, name = null, description = null, contactIds = null, userIds = null) {
    const body = {};

    if (name !== null) {
      body.name = String(name).trim();
    }
    if (description !== null) {
      body.description = description;
    }
    if (contactIds !== null) {
      body.contactIds = Array.isArray(contactIds) ? contactIds : [];
    }
    if (userIds !== null) {
      body.userIds = Array.isArray(userIds) ? userIds : [];
    }

    return fetchWrapper.put(`${process.env.VUE_APP_API_URL}/wanted-contact-groups/${id}`, body);
  }

  async delete(id) {
    return fetchWrapper.delete(`${process.env.VUE_APP_API_URL}/wanted-contact-groups/${id}`);
  }

  /**
   * Lista użytkowników, których można dodać jako członków grupy kontaktów.
   * Endpoint dostępny dla posiadaczy ROLE_14 (nie wymaga dostępu do pełnego /users).
   */
  async getAssignableUsers() {
    const response = await fetchWrapper.get(
      `${process.env.VUE_APP_API_URL}/wanted-contact-groups/assignable-users`
    );

    return Array.isArray(response) ? response : [];
  }
}

export default new ContactGroupsService();
